import React from "react";
import PublicHardware from "@/pages/Hardware";

export default function Hardware() {
  return <PublicHardware variant="console" />;
}
